module.exports = __webpack_public_path__ + "static/media/place-4.8550c93f.webp";